"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectMiddleware = void 0;

var _actions = require("../base/actions");

/**
 * Middleware for redirecting to specified url.
 *
 * @name skybase-core.base.middlewares#redirectMiddleware
 *
 * @method
 */
// eslint-disable-next-line no-unused-vars, no-unused-vars-rest/no-unused-vars
var redirectMiddleware = function redirectMiddleware(store) {
  return function (next) {
    return function (action) {
      var type = action.type;

      var _ref = action.payload || {},
          url = _ref.url;

      switch (type) {
        case _actions.REDIRECT:
          window.location = url;
          break;

        default:
          break;
      }

      return next(action);
    };
  };
};

exports.redirectMiddleware = redirectMiddleware;
//# sourceMappingURL=redirect-middleware.js.map